import { render, staticRenderFns } from "./OrganisationInputs.vue?vue&type=template&id=8abafbc6&"
import script from "./OrganisationInputs.vue?vue&type=script&lang=ts&"
export * from "./OrganisationInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports